import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import ChevronRightIcon from '../icons/heroicons/solid/ChevronRight';
import { useLiffProfile } from '../../context/LiffProfileContext';
import LoadingBar from '../LoadingBar';


const ProfileAvatar = () => {
  const { profile } = useLiffProfile();
  const [loading, setLoading] = useState(false);

  if (!profile) {
    return <LoadingBar loading={loading} />;
  }

  return (
    <Link to="/my-bigpoint" className="flex items-center">
      <div className="rounded-full border-2 border-secondary-background overflow-hidden cursor-pointer w-14 h-14">
        {profile.pictureUrl && (
          <img src={profile.pictureUrl} alt="User Profile" className="w-full h-full" />
        )}
      </div>
      <ChevronRightIcon className="w-6 h-full text-secondary-text-invert" />
    </Link>
  );
};

export default ProfileAvatar;
